import { create } from "zustand";
import { persist } from "zustand/middleware";

const useCustomerStore = create(
    persist(
        (set) => ({
            customers: [],
            setCustomers: (customers) => set({ customers }),
        }),
        {
            name: "customer-store",
        }
    )
);

export default useCustomerStore;